const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function metadataScopeId(metaValue) {
  if (metaValue == null) return null;
  if (typeof metaValue === 'object' && metaValue !== null) {
    return metaValue.id ?? null;
  }
  return metaValue;
}

function metadataDisplayOrder(metaValue) {
  if (metaValue != null && typeof metaValue === 'object' && metaValue !== null) {
    const order = Number(metaValue.order);
    return Number.isFinite(order) ? order : 0;
  }
  return 0;
}

export function mediaFileUrl(filePath) {
  if (!filePath) return '';
  return `${API_URL}${filePath}`;
}

export function filterMediasByMetadata(allMedias, metadataKey, metadataValue) {
  if (!metadataKey || metadataValue == null) return [];

  return (allMedias || [])
    .map((media) => {
      const matchingMeta = (media.metadata || []).find((meta) => {
        if (meta.key !== metadataKey) return false;
        return metadataScopeId(meta.value) === metadataValue;
      });
      if (!matchingMeta) return null;
      return {
        ...media,
        displayOrder: metadataDisplayOrder(matchingMeta.value),
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.displayOrder - b.displayOrder);
}

export function mediasToCarouselItems(medias) {
  return (medias || []).map((media) => ({
    id: media.id,
    url: mediaFileUrl(media.file_path),
    mime_type: media.mime_type,
    filename: media.filename,
    file_path: media.file_path,
  }));
}

const ORDER_METADATA_KEYS = new Set([
  'order_status_draft',
  'order_attachment',
  'order_gallery',
  'order_status_history',
]);

const PRODUCT_METADATA_KEYS = new Set([
  'product_image',
  'product',
  'sku_image',
  'sku',
]);

/**
 * Resolve desktop open context from a MediaGallery metadataKey + metadataValue.
 * Returns { domain: 'order'|'product', entityId: string } or null.
 */
export function resolveDesktopOpenContext(metadataKey, metadataValue) {
  if (!metadataKey || metadataValue == null) return null;
  const entityId = String(
    typeof metadataValue === 'object' && metadataValue !== null
      ? (metadataValue.id ?? metadataValue)
      : metadataValue,
  );
  if (!entityId) return null;
  if (ORDER_METADATA_KEYS.has(metadataKey)) return { domain: 'order', entityId };
  if (PRODUCT_METADATA_KEYS.has(metadataKey)) return { domain: 'product', entityId };
  return null;
}
